// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Disclaimer_dialog__V2pnk","logoContainer":"Disclaimer_logoContainer__2MKbr"};